import React, { createContext, useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react'
import { ThemeProvider } from 'styled-components'

export const LayoutContext = createContext()

const getCurrentTheme = (wideScreen, mobile) =>
  mobile
    ? wideScreen
      ? { calculateResponsiveSize: (px) => `${px / 8.52}vh` }
      : { calculateResponsiveSize: (px) => `${px / 3.93}vw` }
    : wideScreen
      ? { calculateResponsiveSize: (px) => `${px / 7.2}vh` }
      : { calculateResponsiveSize: (px) => `${px / 12.8}vw` }

// No layout effects on the server — avoids React's SSR warning.
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

const LayoutProvider = ({ children }) => {
  /** **** Define current theme values ***** **/
  // Start from the SSR values so hydration matches; the real ones land before paint.
  const [wideScreen, setWideScreen] = useState(true)
  const [mobile, setMobile] = useState(false)
  // Sections (e.g. the pinned scroll-video) can hide the fixed Header while active.
  const [headerHidden, setHeaderHidden] = useState(false)
  const scrollSmoother = useRef(null)

  // Calculate theme synchronously
  const theme = useMemo(() => getCurrentTheme(wideScreen, mobile), [wideScreen, mobile])

  useIsomorphicLayoutEffect(() => {
    const handleResize = () => {
      setWideScreen(window.innerWidth / window.innerHeight >= 1.7777777777777777)
      setMobile(window.innerWidth <= 768)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  /** **** End Define current theme values ***** **/

  return (
    <LayoutContext.Provider
      value={{
        theme,
        mobile,
        scrollSmoother,
        headerHidden,
        setHeaderHidden
      }}
    >
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </LayoutContext.Provider>
  )
}

export default LayoutProvider
